import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the WidgetResultEnps state domain
 */

const selectWidgetResultNpsDomain = (state) =>
  state.get("widgetResultNps", initialState)

/**
 * Other specific selectors
 */
export const makeSelectIsLoading = () =>
  createSelector(selectWidgetResultNpsDomain, (state) => state.get("isLoading"))

export const makeSelectDataNps = () =>
  createSelector(selectWidgetResultNpsDomain, (state) => state.get("dataEnps"))

const makeSelectWidgetResultNps = () =>
  createSelector(selectWidgetResultNpsDomain, (substate) => substate.toJS())

export default makeSelectWidgetResultNps
export { selectWidgetResultNpsDomain }
